import { useEffect } from 'react';

import { NoRefundContent } from './no-refund/NoRefundContent';
import UnderRefundContent from './under-refund/UnderRefundContent';

import { useLookupResultRefundData } from '@/components/tax-refund/lookup/result/LookupResultContext';
import { ApplyPossibleContent } from '@/components/tax-refund/lookup/result/apply-possible/ApplyPossibleContent';
import { useCheckLookPage } from '@/lib/hooks/api/mutation/use-check-look-page';
import { useMarketingLogSend } from '@/lib/hooks/use-marketing-log-send';

export const LookupRefundResultContent = () => {
  const { refundAmount, refundId, refundStatus, tritxRefundInfo } = useLookupResultRefundData();
  const { commit } = useCheckLookPage();

  useMarketingLogSend('조회완료', `${refundAmount}`);

  useEffect(() => {
    if (refundId) {
      commit({ variables: { refundId, pageType: 'SearchRefundAmt' } });
    }
  }, [refundId, commit]);

  if ((refundStatus === 'ApplyPossible' && refundId) || tritxRefundInfo?.refundStatus === 'ApplyPossible') {
    return <ApplyPossibleContent />;
  }
  if (refundAmount === 0 && (!tritxRefundInfo || Number(tritxRefundInfo.refundAmount) === 0)) {
    return <NoRefundContent />;
  }

  return <UnderRefundContent />;
};
